export enum ReefPurpose {
	Customer = "Customer",
	PerformanceTesting = "PerformanceTesting",
	Ephemeral = "Ephemeral"
}